import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { FcmNotification } from "./../../../models/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Observable, Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { COUNTRY_CODES } from "../../data/country-codes";
import { EmployeeAssignForServiceComponent } from "../employee-assign-for-service/employee-assign-for-service.component";
import { EmployeeAssignForCustomiseComponent } from "../employee-assign-for-customise/employee-assign-for-customise.component";
import { CalenderDialogComponent } from "../calender-dialog/calender-dialog.component";
import { SlotTimingsComponent } from "src/app/pages/new-v2-pages/new-v2-component/slot-timings/slot-timings.component";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { InvoiceForReportComponent } from "../invoice-for-report/invoice-for-report.component";
import { InvoiceForFitnessComponent } from "../invoice-for-fitness/invoice-for-fitness.component";
interface InvoiceRange {
  from: Date;
  to: Date;
  fromStr: string;
  toStr: string;
}
@Component({
  selector: "sm-create-invoice-for-fitness",
  templateUrl: "./create-invoice-for-fitness.component.html",
  styleUrls: ["./create-invoice-for-fitness.component.scss"],
})
export class CreateInvoiceForFitnessComponent implements OnInit, OnDestroy {
  isEntityFitness: any = sessionStorage.getItem("isEntityIndividual");
  isEntityIndividual: string = sessionStorage.getItem("isEntityIndividual")!;
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  taxSlabData: any = [];
  productsList: any = [];
  isDropdownSelected: boolean = false;
  form: FormGroup;
  repeatArray: any = new Array(0);
  filteredList: any = [];
  selectedServiceType: any;
  home_status: any = sessionStorage.getItem("home_service_status");
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  private _apiSubscription: Subscription = new Subscription();
  customiseBookingData: any = [];
  employeeList: any = [];
  employeeToAssign: any = [];
  discountInfo: any = null;
  toShowEmployees: boolean = false;
  public newbookingData: any = {
    price: 0,
    discount: 0,
    coupon_discount: 0,
  };
  selectedBookingType: number = 0;
  serviceList: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private http: HttpClient,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
  }
  ngOnInit(): void {
    console.log(this.parentData);
    const currentDate = new Date();
    // this.selectedFromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    // this.selectedToDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const range = this.computeInvoiceRange(
      this.parentData.data.memberData.membership_start_date,
      this.parentData.data.memberData.billing_period,
      this.parentData.data.memberData.pay_in_advance
    );
    this.selectedFromDate = range.from;
    this.selectedToDate = range.to;
    let selectedFromStr = range.fromStr;
    let selectedToStr = range.toStr;

    console.log("Invoice range:", selectedFromStr, "->", selectedToStr);
    this.home_status = sessionStorage.getItem("home_service_status");
    this.shop_status = sessionStorage.getItem("shop_service_status");
    this.virtual_status = sessionStorage.getItem("virtual_service_status");

    if (this.shop_status != 2) {
      this.selectedServiceType = "1";
    } else if (this.home_status != 2) {
      this.selectedServiceType = "0";
    } else if (this.virtual_status != 2) {
      this.selectedServiceType = "2";
    }

    let dateobj = this.getOneHourSlot(new Date());
    this.startTime = dateobj.start;
    this.endTime = dateobj.end;

    console.log(this.parentData.data);
    this.discountInfo = this.parentData.data.discountInfo;
    let data = this.parentData.data;
    if (this.parentData.data.enrolledData) {
      this.newbookingData.customerName =
        this.parentData.data.enrolledData.customer_name;
      this.selectedCountryCode = this.countryList.find(
        (country) =>
          country.dial_code ===
          this.parentData.data.enrolledData.customer_country_code
      );
      this.newbookingData.customerPh =
        this.parentData.data.enrolledData.customer_phone;
    }
    if (this.parentData.data.memberData) {
      this.isDropdownSelected = true;
      this.selectedMember = this.parentData.data.memberData;

      // start operation for services/products

      this.newbookingData.price = this.selectedMember.membership_fee;
      this.newbookingData.discount = this.selectedMember.discount;
      this.selectedServiceType = this.selectedMember.service_mode;

      if (this.selectedMember.custom_items) {
        this.selectedMember.custom_items =
          typeof this.selectedMember.custom_items == "string"
            ? JSON.parse(this.selectedMember.custom_items)
            : this.selectedMember.custom_items;
        this.selectedMember.custom_items.forEach((element: any) => {
          if (element) {
            this.items.push(this.createFieldWithItem(element));
          }
          // if(element.current_status == 3){
          // }
        });
      }
      // this.newbookingData.price = this.selectedMember.membership_fee
    }
    if (this.isEntityForeign == "0") {
      this._apiService.getEntityTaxSlabData(data.entityHash);
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash);
    }

    this._apiService.getServicesTypesList(data.eph, "0", "0");
    this._apiService.getEntityProductList(data.entityHash, "1");

    // this._apiService.getBookingOperationDetails(data.bookingData.hash_id)

    // this._apiService.getEmployeeList(data.entityHash)

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inManageBookings:", resData);
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resData);

        this.serviceList = [];
        if (resData.result) {
          if (this.selectedServiceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shopStatus == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.homeStatus == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.for_virtual == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }

        }
        
        if (this.selectedMember.services) {
          this.selectedMember.services =
            typeof this.selectedMember.services == "string"
              ? JSON.parse(this.selectedMember.services)
              : this.selectedMember.services;
          this.selectedMember.services.forEach((element: any) => {
            this.selectServicesForEdit(element);
          });
        }
        // this.checkCustomiseBookingData(this.customiseBookingData).then((value) => {
        //   // console.log("Customise booking data is available:", data);
        //   if(this.customiseBookingData[0].serviceInfo){
        //     this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
        //       if(element.completed_by && element.completed_by != 'null'){
        //       const totalQty = element.completed_by.reduce((sum:any, data:any) => sum + data.competed_services_qty, 0);
        //       element.total_completed_services_qty = totalQty
        //       this.selectServices(element)
        //       }
        //     });
        //   }
        //   console.log(this.completedJobs);

        // });
        this.calculateCouponDiscount();
        this.loader.showLoader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_FITNESS_AUTOCORRECT
      ) {
        this.filteredList = [];
        if (resData.result) {
          this.filteredList = resData.result;
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();
          if (!this.isPartial) {
            this._modelRef.open(InvoiceComponent, {
              width: "510px",
              data: {
                title: "Invoice",
                ref: this._modelRef,
                data: this.parentData.data.bookingData.hash_id,
              },
            });
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_BOOKING_OPERATION_DETAILS
      ) {
        this.customiseBookingData = [];
        if (resData.result) {
          if (resData.result.serviceInfo) {
            resData.result.serviceInfo = JSON.parse(resData.result.serviceInfo);
          }

          this.customiseBookingData.push(resData.result);
          this.newbookingData.customerName =
            this.customiseBookingData[0].customer_name;
          // this.newbookingData.customerPh = (this.customiseBookingData[0].customer_phone && this.customiseBookingData[0].customer_phone != 'null' && this.customiseBookingData[0].customer_phone != '') ? this.customiseBookingData[0].customer_phone.slice(3) : ''
          this.newbookingData.customerPh =
            this.customiseBookingData[0].customer_phone &&
            this.customiseBookingData[0].customer_phone !== "null" &&
            this.customiseBookingData[0].customer_phone !== ""
              ? this.customiseBookingData[0].customer_phone.slice(-10)
              : "";
          this.selectedCountryCode = this.countryList.find(
            (country) =>
              country.dial_code ===
                this.customiseBookingData[0].customer_phone.slice(0, -10) &&
              country.code === this.countryInfo.code
          );
          this.newbookingData.discount = this.customiseBookingData[0].discount;
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceForFitnessComponent, {
            width: "510px",
            data: {
              title: "Invoice",
              ref: this._modelRef,
              data: resData.result[0].invoice_hash,
              entityHash: this.parentData.data.entityHash,
              memberHash: this.selectedMember.hash_id,
              memberEmail:
                this.parentData.data.enrolledData.customer_email ?? null,
            },
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceForFitnessComponent, {
            width: "510px",
            data: {
              title: "Invoice",
              ref: this._modelRef,
              data: resData.result[0].invoice_hash,
              entityHash: this.parentData.data.entityHash,
              memberHash: this.selectedMember.hash_id,
              memberEmail:
                this.parentData.data.enrolledData.customer_email ?? null,
            },
          });
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resData);
        
        this.productsList = [];
        if (resData.result) {
          if (this.selectedServiceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
          
          
        }

        if (this.selectedMember.products) {
            
            this.selectedMember.products =
              typeof this.selectedMember.products == "string"
                ? JSON.parse(this.selectedMember.products)
                : this.selectedMember.products;
            this.selectedMember.products.forEach((element: any) => {
              this.selectProductsForEdit(element);
            });
          }

        this.calculateCouponDiscount();
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      // if(resData.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT){
      //   this.employeeList = []
      //   if(resData.result){
      //     resData.result.forEach((element:any) => {
      //      if(element.isExEmployee != 1){
      //        this.employeeList.push(element)
      //      }
      //    });
      //   }

      //  }
    });
  }

  changeServiceType(type: string) {
    this.completedJobs = [];
    this.newbookingData.price = 0;
    this.selectedServiceType = type;
    this.loader.showLoader = true;
    this._apiService.getServicesTypesList(this.parentData.data.eph, "0", "0");
    this._apiService.getEntityProductList(this.parentData.data.entityHash, "1");
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  formChecker() {
    if (this.newbookingData.customerPh) {
      if (
        this.newbookingData.customerPh.length >= 3 &&
        this.newbookingData.customerPh.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  /**------------all done and generate bill--------------- */

  serviceInfo: any = [];
  serviceInfoFinalise: any = [];
  productInfo: any = [];
  completedJobs2: any = [];
  onPost() {
    this.completedServices = [];
    this.productInfo = [];
    this.completedJobs.forEach((element: any) => {
      const totalQty = element.completed_by.reduce(
        (sum: any, data: any) => sum + data.total_completed_services_qty,
        0
      );

      this.completedServices.push({
        service_hash: element.service_type_hash,
        service_name: element.service_name,
        service_description: element.description,
        service_img_url: element.img_url,
        service_time: element.approxTime ? element.approxTime : 60,
        service_rate: element.price,
        current_status: 3,
        completed_by_hash_ids: element.completed_by.map((data: any) => {
          return {
            completedByHashId: data.completed_by_hash,
            qty: data.competed_services_qty,
            cost: data.cost,
          };
        }),
        service_qty: element.total_completed_services_qty,
        service_sac_code: element.service_sac_code,
        tax_slab_hash: element.tax_slab_hash,
      });
    });

    this.productInfo = this.completedProducts.map((item: any) => {
      return {
        product_name: item.product_name,
        product_desc: item.description,
        entity_product_hash: item.hash_id,
        product_img_url: item.img_url,
        product_price: item.price,
        product_qty: item.total_completed_services_qty,
        tax_slab_hash: item.tax_slab_hash,
        hsn_code: item.product_hsn_code,
        inventory_item_hash: item.inventory_item_hash,
        purchase_unit: item.purchase_unit,
        selling_unit: item.selling_unit,
        selling_purchase_multiplier: item.selling_purchase_multiplier,
        created_by_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        selling_quantity:
          Math.round(+item.qty_info * item.total_completed_services_qty * 100) /
          100,
        purchase_quantity:
          Math.round(
            ((+item.qty_info * item.total_completed_services_qty) /
              item.selling_purchase_multiplier) *
              100
          ) / 100,
      };
    });

    let data = {
      customer_hash: this.selectedMember.hash_id,
      customer_name: this.newbookingData.customerName
        ? this.newbookingData.customerName
        : "New Customer",
      customer_phone: this.newbookingData.customerPh
        ? this.newbookingData.customerPh
        : "0000000000",
      booking_type: this.selectedServiceType,
      customer_country_code: this.selectedCountryCode.dial_code,
      from_date: this.selectedFromDate
        ? this.formatDate1(this.selectedFromDate)
        : null,
      entity_hash: this.parentData.data.entityHash,
      to_date: this.selectedToDate
        ? this.formatDate1(this.selectedToDate)
        : null,
      services: this.completedServices,
      products: this.productInfo,
      custom_items: this.form.get("items")!.value.map((item: any) => {
        return {
          item_name: item.name.item_name ? item.name.item_name : item.name,
          item_desc: item.name.item_desc ?? "",
          item_inventory_hash: item.name.hash_id ?? "",
          item_img_url: item.name.image_thumb_url ?? "",
          item_qty: item.count,
          item_price: +item.price,
          tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
        };
      }),
      coupon_code:
        this.selectedMember.coupon_use_limit == 0 ||
        this.selectedMember.coupon_use_counter <
          this.selectedMember.coupon_use_limit
          ? this.selectedMember.coupon_code
          : null, //limit > 0
      price: this.newbookingData.price,
      discount: this.newbookingData.discount,
      assignedToHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
      assignedByHash: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
      created_by_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      invoice_type:
        this.isEntityFitness == "1"
          ? this.selectedFromDate && this.selectedToDate
            ? 4
            : 2
          : this.selectedFromDate && this.selectedToDate
          ? 3
          : 1,
      creation_date: this.formatDateString1(new Date()),
    };
    Object.keys(data).forEach((key) => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });

    data.services.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    data.products.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    data.custom_items.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    console.log(data);
    this.loader.showLoader = true;
    if (this.isEntityForeign == "0") {
      this._apiService.addEditFitnessEntityInvoice(data);
    } else if (this.isEntityForeign == "1") {
      this._apiService.addEditInternationalFitnessEntityInvoice(data);
    }
  }

  today = new Date();
  selectedDate: any = null;
  selectedFromDate: any = null;
  selectedToDate: any = null;
  onSelectDate(type: any) {
    const dialogRef = this._modelRef.open(CalenderDialogComponent, {
      width: "350px",
      panelClass: "calender-dialog-container",
      data: {
        selectedDate: this.today,
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      console.log(new Date());

      if (data) {
        console.log(data);

        this.selectedBookingType = type;

        if (type == 1) {
          this.selectedFromDate = data;
          console.log(this.today);
        } else if (type == 2) {
          this.selectedToDate = data;
          console.log(this.today);
        }

        // this.ngOnInit();
      }
    });
  }
  /**-------------------partially done------------------- */
  isPartial: boolean = false;
  completedServices: any = [];
  partiallyDone() {
    this.completedServices = [];
    this.isPartial = true;
    console.log(this.completedJobs);
    this.completedJobs2 = [];
    // this.completedJobs.forEach((element:any) => {
    //   this.completedJobs2.push(element)
    // });
    if (this.customiseBookingData[0].serviceInfo) {
      this.completedJobs.forEach((element: any) => {
        const totalQty = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.competed_services_qty,
          0
        );
        this.completedServices.push({
          service_hash_id: element.service_type_hash,
          service_name: element.service_name,
          description: element.description,
          img_url: element.img_url,
          approxTime: element.approxTime ? element.approxTime : 60,
          completed_by_hash_ids: element.completed_by.map((data: any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost,
            };
          }),
          service_cost: element.price,
          current_status: 3,
          serviceQty: totalQty,
        });
      });
      // this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
      //   const index = this.completedJobs2.findIndex( (x:any)=>x.service_type_hash == element.service_type_hash);
      //   console.log(index);

      //   if(index == -1){
      //     console.log(element);

      //     let data = {
      //       service_type_hash: element.service_type_hash,
      //       service_name: element.service_name,
      //       price: element.price,
      //       note: element.note,
      //       img_url: element.img_url,
      //       employee_name: element.employee_name,
      //       employee_hash_id: element.employee_hash_id,
      //       description: element.description,
      //       current_status: 3,
      //       isDelete: 1
      //     }

      //     this.completedJobs2.push(data)
      //   }
      // });
    } else {
    }

    //     console.log(this.completedJobs2);

    //     this.serviceInfoFinalise = []

    //     this.completedJobs2.forEach((element:any) => {
    //         this.serviceInfoFinalise.push({
    //           service_hash_id: element.service_type_hash,
    //           service_name: element.service_name,
    //           description: element.description,
    //           img_url: element.img_url,
    //           approxTime: element.approxTime ? element.approxTime : 60,
    //           completed_by_hash_ids: element.completed_by,
    //           service_cost: element.price,
    //           current_status: 3,
    //           isDelete: element.isDelete ? element.isDelete : null
    //         })

    //     });

    // this.serviceInfoFinalise.forEach((element:any) => {

    //   Object.keys(element).forEach(key => {
    //     if ((element as any)[key] === null) {
    //       delete (element as any)[key];
    //     }
    //   });

    // });

    let data = {
      appointmentHashId: this.parentData.data.bookingData.hash_id,
      customerName: this.newbookingData.customerName
        ? this.newbookingData.customerName
        : "New Customer",
      customerHashId: this.customiseBookingData[0].customer_hash,
      net_payable: this.newbookingData.price - this.newbookingData.discount,
      totalPrice: this.newbookingData.price,
      booking_current_status: 9,
      customerPhone: this.newbookingData.customerPh
        ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
        : this.selectedCountryCode.dial_code + "0000000000",
      discount: this.newbookingData.discount,
      servicesInfo: this.completedServices,
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.customizeBookingDetails(data);
  }

  allDoneAndRelease() {
    this.isPartial = true;
    this.completedServices = [];
    this.completedJobs2 = [];
    this.completedJobs.forEach((element: any) => {
      this.completedJobs2.push(element);
    });
    if (this.customiseBookingData[0].serviceInfo) {
      this.completedJobs.forEach((element: any) => {
        const totalQty = element.completed_by.reduce(
          (sum: any, data: any) => sum + data.competed_services_qty,
          0
        );
        this.completedServices.push({
          service_hash_id: element.service_type_hash,
          service_name: element.service_name,
          description: element.description,
          img_url: element.img_url,
          approxTime: element.approxTime ? element.approxTime : 60,
          completed_by_hash_ids: element.completed_by.map((data: any) => {
            return {
              completedByHashId: data.completed_by_hash,
              qty: data.competed_services_qty,
              cost: data.cost,
            };
          }),
          service_cost: element.price,
          current_status: 3,
          serviceQty: totalQty,
        });
      });
      // this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
      //   const index = this.completedJobs2.findIndex( (x:any)=>x.service_type_hash == element.service_type_hash);
      //   console.log(index);

      //   if(index == -1){
      //     console.log(element);

      //     let data = {
      //       service_type_hash: element.service_type_hash,
      //       service_name: element.service_name,
      //       price: element.price,
      //       note: element.note,
      //       img_url: element.img_url,
      //       employee_name: element.employee_name,
      //       employee_hash_id: element.employee_hash_id,
      //       description: element.description,
      //       current_status: 3,
      //       isDelete: 1
      //     }

      //     this.completedJobs2.push(data)
      //   }
      // });
    } else {
    }

    //     console.log(this.completedJobs2);

    //     this.serviceInfoFinalise = []

    //     this.completedJobs2.forEach((element:any) => {
    //         this.serviceInfoFinalise.push({
    //           service_hash_id: element.service_type_hash,
    //           service_name: element.service_name,
    //           description: element.description,
    //           img_url: element.img_url,
    //           approxTime: element.approxTime ? element.approxTime : 60,
    //           completed_by_hash_id: element.employee_hash_id,
    //           service_cost: element.price,
    //           current_status: 3,
    //           isDelete: element.isDelete ? element.isDelete : null
    //         })

    //     });

    // this.serviceInfoFinalise.forEach((element:any) => {

    //   Object.keys(element).forEach(key => {
    //     if ((element as any)[key] === null) {
    //       delete (element as any)[key];
    //     }
    //   });

    // });

    let data = {
      appointmentHashId: this.parentData.data.bookingData.hash_id,
      customerName: this.newbookingData.customerName
        ? this.newbookingData.customerName
        : "New Customer",
      customerHashId: this.customiseBookingData[0].customer_hash,
      net_payable: this.newbookingData.price - this.newbookingData.discount,
      totalPrice: this.newbookingData.price,
      booking_current_status: 4,
      customerPhone: this.newbookingData.customerPh
        ? this.selectedCountryCode.dial_code + this.newbookingData.customerPh
        : this.selectedCountryCode.dial_code + "0000000000",
      discount: this.newbookingData.discount,
      servicesInfo: this.completedServices,
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.customizeBookingDetails(data);
  }
  changeChip(value: number) {
    this.selectedDate = null;
    this.selectedBookingType = value;
    if (value == 1) {
      this.selectedDate = new Date();
    } else if (value == 4) {
      let tempDate = new Date();
      tempDate.setDate(tempDate.getDate() - 1);
      this.selectedDate = new Date(tempDate);
    }
  }
  completedJobs: any = [];
  selectServices(item: any) {
    console.log(item);
    if (item.service_type_hash) {
      // being added from api list
      console.log(item);

      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      console.log(index);

      if (index != -1) {
        this.completedJobs.push(item);
        this.newbookingData.price += item.price;

        this.serviceList[index].toShow = false;
      }

      // this.serviceList[index].current_status = 3
    } else if (item.hash_id) {
      // being added from my list
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // this.completedJobs.push(this.serviceList[index])
      console.log(this.serviceList[index]);

      let data = {
        service_type_hash: item.hash_id,
        service_name: item.serviceName,
        price:
          this.selectedServiceType == "0"
            ? item.discountStatus == 1
              ? item.homeDiscountedPrice
              : item.home_rate
            : this.selectedServiceType == "1"
            ? item.discountStatus == 1
              ? item.shopDiscountedPrice
              : item.shop_rate
            : item.discountStatus == 1
            ? item.virtual_discounted_amount
            : item.virtual_rate,
        note: item.note,
        img_url: item.imgUrl,
        service_sac_code: item.service_sac_code,
        tax_slab_hash: item.tax_slab_hash,
        completed_by: [
          {
            cost:
              this.selectedServiceType == "0"
                ? item.discountStatus == 1
                  ? item.homeDiscountedPrice
                  : item.home_rate
                : this.selectedServiceType == "1"
                ? item.discountStatus == 1
                  ? item.shopDiscountedPrice
                  : item.shop_rate
                : item.discountStatus == 1
                ? item.virtual_discounted_amount
                : item.virtual_rate,
            employee_name:
              localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + "(Owner)",
            completed_by_hash: localStorage.getItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
            ),
            competed_services_qty: 1,
          },
        ],
        description: item.description,
        current_status: 3,
        total_completed_services_qty: 1,
      };

      this.completedJobs.push(data);
      this.newbookingData.price += data.price;
      this.serviceList[index].toShow = false;
    }

    console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  selectServicesForEdit(item: any) {
    console.log("item::::::>>>>>",item);
    if (item.service_type_hash) {
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      if (index != -1) {
        // this.serviceList[index].current_status = 3
        item.total_completed_services_qty = item.service_qty;
        this.serviceList[index].total_completed_services_qty = item.service_qty;
        this.serviceList[index].price = item.rate;
        // this.serviceList[index].price = (this.selectedServiceType == '0')
        // ? (this.serviceList[index].discountStatus == 1 ? this.serviceList[index].homeDiscountedPrice* this.serviceList[index].selectedCount : this.serviceList[index].home_rate* this.serviceList[index].selectedCount)
        // : (this.selectedServiceType == '1' ? (this.serviceList[index].discountStatus == 1 ? this.serviceList[index].shopDiscountedPrice* this.serviceList[index].selectedCount : this.serviceList[index].shop_rate* this.serviceList[index].selectedCount)
        // : (this.serviceList[index].discountStatus == 1 ? this.serviceList[index].virtual_discounted_amount* this.serviceList[index].selectedCount : this.serviceList[index].virtual_rate* this.serviceList[index].selectedCount) )

        let data = {
          service_type_hash: item.service_type_hash,
          service_name: item.service_name,
          price: item.rate,
          note: "",
          img_url: item.img_url,
          service_sac_code: this.serviceList[index].service_sac_code,
          tax_slab_hash: this.serviceList[index].tax_slab_hash,
          completed_by: [],
          description: item.description,
          current_status: 3,
          total_completed_services_qty: item.service_qty,
        };

        this.completedJobs.push(data);
        console.log(this.completedJobs);

        this.serviceList[index].toShow = false;
      }
      else{
        let data = {
        service_type_hash: item.service_type_hash,
        service_name: item.service_name,
        price: item.rate,
        note: "",
        img_url: item.img_url,
        service_sac_code: null,
        tax_slab_hash: null,
        completed_by: [],
        description: item.description,
        current_status: 3,
        total_completed_services_qty: item.service_qty,
      };

      this.completedJobs.push(data);
      }
    } else {
      let data = {
        service_type_hash: item.service_type_hash,
        service_name: item.service_name,
        price: item.rate,
        note: "",
        img_url: item.img_url,
        service_sac_code: null,
        tax_slab_hash: null,
        completed_by: [],
        description: item.description,
        current_status: 3,
        total_completed_services_qty: item.service_qty,
      };

      this.completedJobs.push(data);
    }
    this.calculateCouponDiscount();
  }

  completedProducts: any = [];
  selectProducts(item: any) {
    console.log(item);
    if (item.service_type_hash) {
      // being added from api list
      console.log(item);

      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      console.log(index);

      if (index != -1) {
        this.completedJobs.push(item);
        this.newbookingData.price += item.price;

        this.serviceList[index].toShow = false;
      }

      // this.serviceList[index].current_status = 3
    } else if (item.hash_id) {
      // being added from my list
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );

      let data = {
        hash_id: item.hash_id,
        product_name: item.product_name,
        price:
          this.selectedServiceType == "0"
            ? item.discount_status == 1
              ? item.home_discounted_price
              : item.home_price
            : this.selectedServiceType == "1"
            ? item.discount_status == 1
              ? item.shop_discounted_price
              : item.shop_price
            : item.discount_status == 1
            ? item.virtual_discounted_price
            : item.virtual_price,
        tax_slab_hash: item.tax_slab_hash,
        product_hsn_code: item.product_hsn_code,
        img_url: item.thumb_image_url,

        description: item.product_desc,
        total_completed_services_qty: 1,
        inventory_item_hash: item.inventory_item_hash,
        purchase_unit: item.purchase_unit,
        selling_unit: item.selling_unit,
        selling_purchase_multiplier: item.selling_purchase_multiplier,
        qty_info: item.qty_info,
      };

      this.completedProducts.push(data);
      this.newbookingData.price += data.price;
      this.productsList[index].toShow = false;
    }

    // console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  selectProductsForEdit(item: any) {
    console.log("item:::::>>>>>",item);
    if (item.entity_product_hash) {
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash
      );
      if (index != -1) {
        this.productsList[index].total_completed_services_qty =
          item.product_qty;
        item.total_completed_services_qty = item.product_qty;
        this.productsList[index].price = item.rate;

     

        this.completedProducts.push(this.productsList[index]);

        this.productsList[index].toShow = false;
      }
      else{
          let data = {
        hash_id: item.hash_id,
        product_name: item.product_name,
        price: item.rate,
        tax_slab_hash: item.tax_slab_hash,
        product_hsn_code: null,
        img_url: item.img_url,
        description: item.description,
        total_completed_services_qty: item.product_qty,
        inventory_item_hash: null,
        purchase_unit: '',
        selling_unit: '',
        selling_purchase_multiplier: 1,
        qty_info: '',
      };

      this.completedProducts.push(data);
      }
    }else{
      let data = {
            hash_id: item.hash_id,
        product_name: item.product_name,
        price: item.rate,
        tax_slab_hash: item.tax_slab_hash,
        product_hsn_code: null,
        img_url: item.img_url,
        description: item.description,
        total_completed_services_qty: item.product_qty,
        inventory_item_hash: null,
        purchase_unit: '',
        selling_unit: '',
        selling_purchase_multiplier: 1,
        qty_info: '',
      };

      this.completedProducts.push(data);

    }
    this.calculateCouponDiscount();
  }

  // changeServicePrice(item:any){
  //   console.log(item.price);
  //   this.newbookingData.price = 0
  //   this.completedJobs.forEach((element:any) => {
  //     this.newbookingData.price += element.price
  //   });
  //   this.checkIfEmpty()
  //   this.calculateDiscount()
  // }
  // changeProductPrice(item:any){
  //   console.log(item.price);
  //   this.newbookingData.price = 0
  //   this.completedProducts.forEach((element:any) => {
  //     this.newbookingData.price += element.price
  //   });
  //   this.checkIfEmptyForProduct()
  //   this.calculateDiscount()
  // }

  changeServicePrice(item: any) {
    console.log(item.price);
    this.newbookingData.price = 0;
    this.completedJobs.forEach((element: any) => {
      this.newbookingData.price += element.price;
    });
    this.completedProducts.forEach((element: any) => {
      this.newbookingData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.newbookingData.price += +element.price;
    });

    this.checkIfEmpty();
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  changeProductPrice(item: any) {
    console.log(item.price);
    this.newbookingData.price = 0;
    this.completedJobs.forEach((element: any) => {
      this.newbookingData.price += element.price;
    });
    this.completedProducts.forEach((element: any) => {
      this.newbookingData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.newbookingData.price += +element.price;
    });

    this.checkIfEmptyForProduct();
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  selectEmployeeToAssign(item: any) {
    this.employeeToAssign = [];
    this.employeeList.forEach((element: any) => {
      element.selected = false;
    });
    item.selected = true;

    this.employeeToAssign.push(item);

    // this.selectedTopicHashId = item.hash_id
    // this.selectedTopicName = item.topic_name
  }

  assignEmployee(item: any, index: any) {
    console.log(item);

    let dialogref = this._modelRef.open(EmployeeAssignForCustomiseComponent, {
      width: "600px",
      disableClose: true,
      data: {
        data: item,
        serviceType: this.selectedServiceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);

        this.completedJobs[index] = res;
        console.log(this.completedJobs);
        if (!res.completed_by || res.completed_by.length == 0) {
          const index1 = this.serviceList.findIndex(
            (x: any) => x.hash_id == item.service_type_hash
          );
          this.serviceList[index1].toShow = true;
          this.completedJobs.splice(index, 1);
        }
        this.newbookingData.price = 0;
        this.completedJobs.forEach((element: any) => {
          element.completed_by.forEach((item: any) => {
            this.newbookingData.price += item.cost;
          });
        });
        this.calculateDiscount();
        this.calculateCouponDiscount();
      }
    });
    // this.toAssignEmployeeService.employee_name = this.employeeToAssign[0].name
    // this.toAssignEmployeeService.employee_hash_id = this.employeeToAssign[0].employeeHashId
    // this.toShowEmployees = false
    // this.employeeToAssign = []
    // this.employeeList.forEach((element:any) => {
    //   element.selected = false
    // });
  }
  removeCompletedJobs(item: any) {
    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.service_type_hash
    );
    const index1 = this.completedJobs.findIndex(
      (x: any) => x.service_type_hash == item.service_type_hash
    );
    this.newbookingData.price -= this.completedJobs[index1].price;
    if(index != -1){
      this.serviceList[index].toShow = true;

    }
    this.completedJobs.splice(index1, 1);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  removeCompletedProducts(item: any) {
    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );
    const index1 = this.completedProducts.findIndex(
      (x: any) => x.hash_id == item.hash_id
    );

    this.newbookingData.price -= this.completedProducts[index1].price;
    if(index != -1){
      this.productsList[index].toShow = true;
    }
    this.completedProducts.splice(index1, 1);

    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  toAssignEmployeeService: any;
  showEmployee(item: any) {
    this.toAssignEmployeeService = item;
    this.toShowEmployees = !this.toShowEmployees;
  }
  hideEmployee() {
    this.toShowEmployees = !this.toShowEmployees;
  }
  decreaseServiceCount(item: any, index: any) {
    if (this.completedJobs[index].total_completed_services_qty == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      if(index1 != -1){
        this.newbookingData.price -=
          this.completedJobs[index].price /
          this.completedJobs[index].total_completed_services_qty;
        this.serviceList[index1].toShow = true;
        this.completedJobs.splice(index, 1);

      }
      else{
        this.newbookingData.price -=
          this.completedJobs[index].price /
          this.completedJobs[index].total_completed_services_qty;
        this.completedJobs.splice(index, 1);
        
      }
    } else {
      console.log(item);

      this.newbookingData.price -=
        this.completedJobs[index].price /
        this.completedJobs[index].total_completed_services_qty;

      this.completedJobs[index].price -=
        this.completedJobs[index].price /
        this.completedJobs[index].total_completed_services_qty;

      this.completedJobs[index].total_completed_services_qty--;
    }
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  increaseServiceCount(item: any, index: any) {
    this.newbookingData.price += item.price / item.total_completed_services_qty;

    const index1 = item.completed_by.findIndex(
      (x: any) =>
        x.completed_by_hash ==
        localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)
    );
    console.log(index1);


    if (index1 == -1) {
      // item.completed_by.push({
      //   cost: item.price,
      //   employee_name:
      //     localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + "(Owner)",
      //   completed_by_hash: localStorage.getItem(
      //     SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
      //   ),
      //   competed_services_qty: 1,
      // });
    } else {
      // item.completed_by[index1].cost +=
      //   item.price / item.total_completed_services_qty;
      // item.completed_by[index1].competed_services_qty += 1;
    }
    item.price += item.price / item.total_completed_services_qty;
    item.total_completed_services_qty++;
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  decreaseProductCount(item: any, index: any) {
    if (this.completedProducts[index].total_completed_services_qty == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );

      if(index1 != -1){
        this.newbookingData.price -=
          this.completedProducts[index].price /
          this.completedProducts[index].total_completed_services_qty;
        this.productsList[index1].toShow = true;
        this.completedProducts.splice(index, 1);

      }
      else{
        this.newbookingData.price -=
          this.completedProducts[index].price /
          this.completedProducts[index].total_completed_services_qty;
        this.completedProducts.splice(index, 1);

      }

    } else {
      this.newbookingData.price -=
        this.completedProducts[index].price /
        this.completedProducts[index].total_completed_services_qty;

      this.completedProducts[index].price -=
        this.completedProducts[index].price /
        this.completedProducts[index].total_completed_services_qty;
      this.completedProducts[index].total_completed_services_qty--;
    }
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  increaseProductCount(item: any, index: any) {
    this.newbookingData.price += item.price / item.total_completed_services_qty;

    item.price += item.price / item.total_completed_services_qty;
    item.total_completed_services_qty++;
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  checkCustomiseBookingData(customiseBookingData: any): Promise<any> {
    console.log("hitting");

    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        // console.log("hitting");
        if (customiseBookingData && customiseBookingData.length > 0) {
          clearInterval(intervalId);
          resolve(customiseBookingData);
        }
      }, 100); // interval time (adjust as needed)
    });
  }
  emptyCheck: boolean = false;
  checkIfEmpty() {
    return this.completedJobs.some(
    (element: any) => element.price === "" || element.price == null
  );
  }
  emptyCheckForProduct: boolean = false;
  checkIfEmptyForProduct() {
     return this.completedProducts.some(
    (element: any) => element.price === "" || element.price == null
  );
  }

  addOneHourAndFormat(date: Date): string {
    const newDate = new Date(date);
    newDate.setHours(date.getHours() + 1);

    const hours = newDate.getHours().toString().padStart(2, "0");
    const minutes = newDate.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  startTime: any = null;
  endTime: any = null;
  onSelectSlot() {
    this.loader.showLoader = true;
    let dialogref = this._modelRef.open(SlotTimingsComponent, {
      data: {
        isToday: this.selectedBookingType == 1 ? true : false,
        day: this.selectedDate
          ? new Date(this.selectedDate).getDay() + 1
          : new Date(this.today).getDay() + 1,
        entityHash: "jjjj",
        serviceType: this.selectedServiceType,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.startTime = res.startTime;
        this.endTime = res.endTime;
      }
    });
  }
  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  getOneHourSlot(date: Date) {
    // Convert to local time string in 24-hour format
    const localTimeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Get hours and minutes
    let [hours, minutes] = localTimeString.split(":").map(Number);

    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;

    // Calculate next hour
    let endHour = (startHour + 1) % 24;

    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour: any) => hour.toString().padStart(2, "0");

    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`,
    };
  }

  discountCalculated: boolean = false;
  calculateDiscount() {
    if (
      !this.selectedMember.discount ||
      this.selectedMember.discount == 0 ||
      this.newbookingData.discount == 0 ||
      !this.newbookingData.discount ||
      this.newbookingData.discount == "" ||
      this.discountCalculated
    ) {
      this.discountCalculated = true;
      this.newbookingData.discount = 0;

      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.selectedServiceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount =
                      this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.selectedServiceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount =
                      this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
              // virtual service
              else if (this.selectedServiceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount =
                      this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.selectedServiceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  this.newbookingData.discount =
                    this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.selectedServiceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  this.newbookingData.discount =
                    this.discountInfo.discountAmount;
                }
              }
              // virtual service
              else if (this.selectedServiceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  this.newbookingData.discount =
                    this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }

      this.newbookingData.discount = +this.newbookingData.discount.toFixed(2);
    }
  }

  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  firstTimeBelow3: boolean = false;

  searchNameData() {
    this.isDropdownSelected = false;
    if (this.newbookingData.customerName.length >= 3) {
      this.firstTimeBelow3 = true;
      this._apiService.getFitnessEnrolledMemberForAutoCorrect(
        this.parentData.data.entityHash,
        this.newbookingData.customerName
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.filteredList = [];
        // this._apiService.getFitnessEnrolledMemberForAutoCorrect(this.parentData.data.entityHash,'');
      }
    }
  }
  selectedMember: any;
  onClickName(item: any) {
    this.selectedMember = item;
    this.newbookingData.customerName = item.name;
    this.selectedCountryCode = this.countryList.find(
      (country) =>
        country.dial_code === item.country_code &&
        country.code === this.countryInfo.code
    );
    this.newbookingData.customerPh = item.phone;
    this.isDropdownSelected = true;
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    this.newbookingData = {
      price: 0,
    };
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): FormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as FormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }

      this.calculateDiscount();
      this.calculateCouponDiscount();
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }
  createFieldWithItem(item: any): FormGroup {
    const itemGroup = this.fb.group({
      name: [
        {
          item_name: item.item_name,
          item_desc: item.item_description,
          hash_id: item.inventory_item_hash,
          image_thumb_url: null,
        },
        Validators.required,
      ],
      price: [item.item_price, Validators.required],
      count: [item.item_qty, Validators.required],
      tax_slab: [item.tax_slab_hash ? item.tax_slab_hash : "default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    const filteredOption = filterControl.valueChanges.pipe(
      debounceTime(300),
      filter((value) => typeof value === "string" && value.length > 2),
      switchMap((value) => this.fetchOptions(value))
    );
    this.filteredOptions.push(filteredOption);
    const priceControl = itemGroup.get("price") as FormControl;
    let previousPrice = item.item_price; // ✅ Set to initial price
    // Add initial price to total once
    // this.newbookingData.price += item.item_price;
    priceControl.valueChanges.subscribe((value) => {
      console.log("yeahhhhhh", value);

      const parsedValue = Number(value);
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + parsedValue;
        previousPrice = parsedValue;
      }
      // Recalculate total price from scratch
      // this.newbookingData.price = 0;

      // // Completed jobs
      // this.completedJobs.forEach((element: any) => {
      //   const val = Number(element.price);
      //   if (!isNaN(val)) this.newbookingData.price += val;
      // });

      // // Completed products
      // this.completedProducts.forEach((element: any) => {
      //   const val = Number(element.price);
      //   if (!isNaN(val)) this.newbookingData.price += val;
      // });

      // // Current form items
      // const items = this.form.get("items")?.value || [];
      // items.forEach((element: any) => {
      //   console.log(element.price);

      //   const val = Number(element.price);
      //   if (!isNaN(val)) this.newbookingData.price += val;
      // });

      this.calculateDiscount();
      this.calculateCouponDiscount();
    });

    return itemGroup;
  }
  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // Get the form array of items
  get items(): FormArray {
    return this.form.get("items") as FormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.newbookingData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.newbookingData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }
  formatDateString1(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  calculateCouponDiscount() {
    if (this.selectedMember.coupon_code) {
      if (
        this.selectedMember?.coupon_use_limit == 0 ||
        this.selectedMember?.coupon_use_limit >
          this.selectedMember?.coupon_use_counter
      ) {
        this.newbookingData.coupon_discount = 0;
        console.log("inside coupon");

        // percentage discount
        if (this.selectedMember.coupon_info.discount_type == 1) {
          if (
            this.newbookingData.price >=
            this.selectedMember.coupon_info.minimum_cart_value
          ) {
            let cal_disc =
              (+this.selectedMember.coupon_info.discount_value / 100) *
              +this.newbookingData.price;
            if (cal_disc >= this.selectedMember.coupon_info.max_discount) {
              this.newbookingData.coupon_discount =
                this.selectedMember.coupon_info.max_discount;
            } else {
              this.newbookingData.coupon_discount = cal_disc;
            }
            // // home service
            // if (this.parentData.data.serviceType == "0") {
            //   if (this.discountInfo.home_service_status == 1) {
            //   }
            // }
            // // shop service
            // else if (this.parentData.data.serviceType == "1") {
            //   if (this.discountInfo.shop_service_status == 1) {
            //     let cal_disc =
            //       (+this.discountInfo.discountAmount / 100) *
            //       +this.newbookingData.price;
            //     console.log(cal_disc);

            //     if (cal_disc >= this.discountInfo.maxDiscount) {
            //       this.newbookingData.discount = this.discountInfo.maxDiscount;
            //     } else {
            //       this.newbookingData.discount = cal_disc;
            //     }
            //   }
            // }
            // // virtual service
            // else if (this.parentData.data.serviceType == "2") {
            //   if (this.discountInfo.virtual_service_status == 1) {
            //     let cal_disc =
            //       (+this.discountInfo.discountAmount / 100) *
            //       +this.newbookingData.price;
            //     console.log(cal_disc);

            //     if (cal_disc >= this.discountInfo.maxDiscount) {
            //       this.newbookingData.discount = this.discountInfo.maxDiscount;
            //     } else {
            //       this.newbookingData.discount = cal_disc;
            //     }
            //   }
            // }
          }
        }
        // amount discount
        else if (this.selectedMember.coupon_info.discount_type == 2) {
          if (
            this.newbookingData.price >=
            this.selectedMember.coupon_info.minimum_cart_value
          ) {
            this.newbookingData.coupon_discount =
              this.selectedMember.coupon_info.discount_value;

            // // home service
            // if (this.parentData.data.serviceType == "0") {
            //   if (this.discountInfo.home_service_status == 1) {
            //   }
            // }
            // // shop service
            // else if (this.parentData.data.serviceType == "1") {
            //   if (this.discountInfo.shop_service_status == 1) {
            //     this.newbookingData.discount = this.discountInfo.discountAmount;
            //   }
            // }
            // // virtual service
            // else if (this.parentData.data.serviceType == "2") {
            //   if (this.discountInfo.virtual_service_status == 1) {
            //     this.newbookingData.discount = this.discountInfo.discountAmount;
            //   }
            // }
          }
        }

        // this.newbookingData.discount = +this.newbookingData.discount.toFixed(2);
      }
    }
  }

  changedDiscountByBusiness(event: any) {
    console.log(event);
    this.discountCalculated = false;
  }



computeInvoiceRange(
  this: any,
  membershipStartInput: string | Date | null,
  billingPeriod: number, // 1=Weekly, 2=Monthly, 3=Yearly, 4=Quarterly, 5=Semi-Annually
  payInAdvance: number,  // 0 = Previous/Arrears, 1 = Next/Current
  nowInput?: Date
): InvoiceRange {
  const now = nowInput ? new Date(nowInput) : new Date();
  const today = this.startOfDay(now);
  const membershipStart = membershipStartInput
    ? this.startOfDay(new Date(membershipStartInput))
    : null;

  // 1. WEEKLY (7 Days) - Pure Math
  if (billingPeriod === 1) {
    if (!membershipStart) return this.getFallback(today);
    
    // Calculate exact weeks passed
    const oneWeek = 7 * 24 * 60 * 60 * 1000;
    const diffTime = today.getTime() - membershipStart.getTime();
    
    // Floor ensures we get the "current active" week start
    let weeksPassed = Math.floor(diffTime / oneWeek);
    
    // Safety: If start date is future, handle it
    if (weeksPassed < 0) weeksPassed = 0;

    // Logic:
    // If PayInAdvance=1 (Current), we want the week derived from weeksPassed.
    // If PayInAdvance=0 (Previous), we want weeksPassed - 1.
    
    let targetWeekIndex = weeksPassed;
    if (payInAdvance === 0) {
      targetWeekIndex = weeksPassed - 1;
      // Boundary: Cannot go before start
      if (targetWeekIndex < 0) targetWeekIndex = 0;
    }

    const start = this.addDays(membershipStart, targetWeekIndex * 7);
    const end = this.addDays(start, 6); // Inclusive end
    return this.formatResult(start, end);
  }

  // 2. MONTHLY / YEARLY / ETC (Anchor Logic)
  // 2=1m, 3=1y, 4=3m, 5=6m
  if ([2, 3, 4, 5].includes(billingPeriod)) {
    if (!membershipStart) return this.getFallback(today);

    // Define the multiplier (1 month, 3 months, 6 months, 12 months)
    let monthsPerPeriod = 1;
    if (billingPeriod === 3) monthsPerPeriod = 12; // Yearly treated as 12 months for anchor safety
    if (billingPeriod === 4) monthsPerPeriod = 3;
    if (billingPeriod === 5) monthsPerPeriod = 6;

    // ANCHOR ALGORITHM:
    // We estimate how many periods have passed, then check strictly against Today.
    // This allows "Jan 31" + 2 months to effectively become "Mar 31".
    
    // Estimate N (periods passed) based on years/months diff
    let diffMonths = (today.getFullYear() - membershipStart.getFullYear()) * 12;
    diffMonths -= membershipStart.getMonth();
    diffMonths += today.getMonth();
    
    // Approximate periods passed
    let n = Math.floor(diffMonths / monthsPerPeriod);
    if (n < 0) n = 0;

    // Find the actual "Current Active Period" relative to Today
    // We check cycle(n). If it ends before today, check cycle(n+1). If it starts after today, check cycle(n-1).
    
    let currentStart: Date;
    let currentEnd: Date;

    // We use a small loop to fine-tune because days-in-month vary
    while (true) {
      const s = this.addMonthsAnchor(membershipStart, n * monthsPerPeriod);
      // End is Start + 1 Period - 1 Day
      // Important: End is calculated from Anchor too to ensure e.g. Jan 31 + 1m = Feb 29 end.
      const nextS = this.addMonthsAnchor(membershipStart, (n + 1) * monthsPerPeriod);
      const e = this.addDays(nextS, -1);

      if (e.getTime() < today.getTime()) {
        // This period is finished. Try next.
        n++;
      } else if (s.getTime() > today.getTime() && n > 0) {
        // This period is in the future. Try previous.
        n--;
      } else {
        // This is the one! (s <= today <= e)
        currentStart = s;
        currentEnd = e;
        break;
      }
    }

    // Now apply PayInAdvance Logic
    if (payInAdvance === 1) {
      // Return Current
      return this.formatResult(currentStart, currentEnd);
    } else {
      // Return Previous
      if (n === 0) {
        // Cannot go back before start
        return this.formatResult(currentStart, currentEnd);
      }
      
      // Calculate period N-1
      const prevStart = this.addMonthsAnchor(membershipStart, (n - 1) * monthsPerPeriod);
      const prevEnd = this.addDays(this.addMonthsAnchor(membershipStart, n * monthsPerPeriod), -1);
      return this.formatResult(prevStart, prevEnd);
    }
  }

  return this.getFallback(today);
}


// --- HELPER FUNCTIONS ---

formatResult(start: Date, end: Date): InvoiceRange {
  return {
    from: this.startOfDay(start),
    to: this.startOfDay(end),
    fromStr: this.formatISODateTime(this.startOfDay(start)),
    toStr: this.formatISODateTime(this.startOfDay(end)),
  };
}

startOfDay(d: Date) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

getFallback(today: Date) {
   const defStart = this.addDays(today, -6);
   const defEnd = this.startOfDay(today);
   return this.formatResult(defStart, defEnd);
}

addDays(d: Date, days: number) {
  const x = new Date(d);
  x.setDate(x.getDate() + days);
  return x;
}

/**
 * ANCHOR ADD MONTHS
 * Adds 'months' to the 'original' date.
 * Handles clamping: Jan 31 + 1 month = Feb 28/29.
 * But Jan 31 + 2 months = Mar 31 (Snaps back).
 */
addMonthsAnchor(original: Date, monthsToAdd: number) {
  const y = original.getFullYear();
  const m = original.getMonth();
  const d = original.getDate();

  const targetDate = new Date(y, m + monthsToAdd, 1);
  const targetY = targetDate.getFullYear();
  const targetM = targetDate.getMonth();

  // Get last day of that target month
  const daysInTargetMonth = new Date(targetY, targetM + 1, 0).getDate();

  // Clamp the day: Min(Original Day, DaysInTarget)
  // This ensures Jan 31 becomes Feb 28, but stays 31 for March
  const finalDay = Math.min(d, daysInTargetMonth);

  return new Date(targetY, targetM, finalDay);
}

formatISODateTime(d: Date) {
  const z = (n: number) => (n < 10 ? "0" + n : "" + n);
  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())} ${z(
    d.getHours()
  )}:${z(d.getMinutes())}:${z(d.getSeconds())}`;
}

  get isSubmitDisabled(): boolean {
  const items = this.form.get('items') as FormArray;
  
  return (
    (!this.newbookingData.price &&
      this.completedJobs.length === 0 &&
      this.completedProducts.length === 0 &&
      items.length === 0) ||
      this.formChecker()
      || !this.endTime || !this.startTime || this.checkIfEmpty() || this.form.invalid || this.checkIfEmptyForProduct()
  );
}
}
